<template>
  <v-row class="full-width text-left">
    <v-col cols="12">
      <Typography variant="h-2">Audit Rules</Typography>
      <Typography variant="body-1" class="mt-4"
        ><strong>Default Audit Frequency</strong></Typography
      >
      <Typography variant="body-2"
        >This percentage will be the default value for the amount of claims that will be sent for
        audit.</Typography
      >
      <v-form v-model="validForm">
        <div id="audit-percent-container">
          <v-text-field
            v-model="auditPercent"
            label="Audit Percent"
            type="number"
            min="0"
            max="100"
            class="mt-4"
            outlined
            color="brandCyan"
            suffix="%"
            :disabled="isSaving || isLoading"
            :rules="auditRules"
          />
        </div>
        <div class="d-flex justify-center mt-4">
          <Button
            color="brandCyan"
            @click="handleSave"
            :loading="isSaving"
            :disabled="isSaving || isLoading || !validForm"
          >
            Save Changes</Button
          >
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
// Components
import Typography from "@/components/generic/Typography";
import Button from "@/components/generic/Button";
import { mapState } from "vuex";

// Mixins
import clientSupplementalMixin from "@/mixins/clientSupplementalMixin";

// Constants
const DEFAULT_AUDIT_PERCENT = 0;
const AUDIT_PERCENT_KEY = "claim_audit_percentage";

export default {
  name: "ClaimAuditRules",
  components: {
    Typography,
    Button,
  },
  mixins: [clientSupplementalMixin],
  props: {
    setAuditPercent: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      auditPercent: DEFAULT_AUDIT_PERCENT,
      clientSupplementalId: null,
      isLoading: false,
      isSaving: false,
      validForm: false,
      auditRules: [(v) => (v >= 0 && v <= 100) || "Audit percentage must be between 0 and 100"],
    };
  },
  mounted() {
    this.getAuditPercent();
  },
  computed: {
    ...mapState(["globalClientId"]),
  },
  methods: {
    async getAuditPercent() {
      this.isLoading = true;
      try {
        const { value, clientSupplementalId } = await this.getClientSupplemental({
          clientId: this.globalClientId,
          key: AUDIT_PERCENT_KEY,
          errorContext: "Failed to get audit configuration",
        });
        this.auditPercent = Number(value || DEFAULT_AUDIT_PERCENT);
        this.clientSupplementalId = clientSupplementalId;
      } catch (e) {
        console.log("Error loading audit configuration", e);
      } finally {
        this.isLoading = false;
      }
    },
    async handleSave() {
      this.isSaving = true;
      try {
        const { clientSupplementalId } = await this.saveClientSupplemental({
          clientId: this.globalClientId,
          key: AUDIT_PERCENT_KEY,
          value: this.auditPercent,
          clientSupplementalId: this.clientSupplementalId,
          updateErrorContext: "Failed to update audit configuration",
          createErrorContext: "Failed to create audit configuration",
        });
        this.clientSupplementalId = clientSupplementalId;

        this.$store.dispatch("showSnackbar", {
          text: "Audit configuration saved",
          color: "brandCyan",
        });
      } catch (e) {
        console.log("Error saving audit configuration", e);
      } finally {
        this.isSaving = false;
      }
    },
  },
  watch: {
    globalClientId: function (newVal, oldVal) {
      // If client id changes, we get budgets!
      if (newVal != oldVal && oldVal != null) {
        this.getAuditPercent();
      }
    },
  },
};
</script>
<style scoped>
#audit-percent-container {
  max-width: 225px;
  width: 100%;
}
</style>
